// RPA 详情页的实时画面连接与人工接管弹窗生命周期。
import { LAUNCHER_HAS_SCREENSHOT_STATUS } from '@/constant/rpa'

export default {
  data () {
    return {
      controlIframeSrc: null,
      screenTimer: null,
      dialog: {
        show: false,
        loading: false,
        // 接管弹窗轮次，用于拒绝关闭或重新打开前的迟到请求和布局回调。
        sessionGeneration: 0,
        layoutTimer: null
      },
      monitor: {
        loading: false,
        autoRefresh: true,
        // 实时查看轮次，用于拒绝上一轮连接或截图请求的迟到结果。
        sessionGeneration: 0,
        frame: 2,
        socket: null,
        objectUrl: null,
        src: null,
        image: null,
        dialog: {
          show: false,
          loading: false
        }
      }
    }
  },
  methods: {
    async initMonitor () {
      if (!this.taskSetting.autoRefresh || !this.hasSuperAdminPermission || !LAUNCHER_HAS_SCREENSHOT_STATUS.includes(this.botStatus)) {
        this.stopMonitor()
        return
      }
      const monitor = this.monitor
      // 初始化请求、实时连接或截图轮询仍有效时，状态刷新不重建画面。
      if (monitor.autoRefresh && (monitor.loading || monitor.socket || monitor.src)) return
      this.stopMonitor()
      const monitorGeneration = monitor.sessionGeneration
      monitor.loading = true
      monitor.autoRefresh = true
      try {
        const resp = await this.getTaskScreenshot({ task_id: this.taskId, taskBackend: this.taskBackend })
        if (!monitor.autoRefresh || monitorGeneration !== monitor.sessionGeneration) return
        monitor.src = resp?.screenshot || null
        if (resp?.view_stream) {
          this.connectMonitorStream(resp.view_stream, monitorGeneration)
        } else if (monitor.src) {
          this.refreshMonitor(monitorGeneration)
        } else {
          // STARTING 时通道可能尚未建立；不因首次无地址永久停止查看。
          this.screenTimer = setTimeout(() => this.initMonitor(), 1000 / monitor.frame)
        }
      } catch (err) {
        if (monitorGeneration === monitor.sessionGeneration) this.stopMonitor()
        // eslint-disable-next-line no-console
        console.error(err)
      } finally {
        if (monitorGeneration === monitor.sessionGeneration) monitor.loading = false
      }
    },
    stopMonitor () {
      clearTimeout(this.screenTimer)
      this.screenTimer = null
      this.monitor.sessionGeneration += 1
      if (this.monitor.socket) {
        this.monitor.socket.close()
        this.monitor.socket = null
      }
      if (this.monitor.objectUrl) {
        URL.revokeObjectURL(this.monitor.objectUrl)
        this.monitor.objectUrl = null
      }
      this.monitor.autoRefresh = false
      this.monitor.loading = false
      this.monitor.src = null
      this.monitor.image = null
    },
    connectMonitorStream (viewStream, monitorGeneration) {
      // viewStream 含同源连接路径和一次性查看凭据；monitorGeneration 绑定本次查看轮次。
      const monitor = this.monitor
      const endpoint = new URL(viewStream.path, window.location.href)
      if (endpoint.origin !== window.location.origin || !viewStream.token) {
        this.stopMonitor()
        return
      }
      endpoint.protocol = endpoint.protocol === 'https:' ? 'wss:' : 'ws:'
      const socket = new WebSocket(endpoint.href)
      monitor.socket = socket
      const isCurrentMonitorConnection = () => monitor.autoRefresh && monitorGeneration === monitor.sessionGeneration && monitor.socket === socket
      socket.onopen = () => {
        if (!isCurrentMonitorConnection()) return socket.close()
        // token 只在首条消息中提交，不出现在请求 URL 或访问日志中。
        socket.send(JSON.stringify({ type: 'claim-view', token: viewStream.token }))
      }
      socket.onmessage = event => {
        if (!isCurrentMonitorConnection()) return
        if (typeof event.data === 'string') {
          try {
            if (JSON.parse(event.data).type === 'error') socket.close()
          } catch (error) {
            socket.close()
          }
          return
        }
        const previousUrl = monitor.objectUrl
        monitor.objectUrl = URL.createObjectURL(new Blob([event.data], { type: 'image/jpeg' }))
        monitor.image = monitor.objectUrl
        monitor.loading = false
        if (previousUrl) URL.revokeObjectURL(previousUrl)
      }
      socket.onerror = () => socket.close()
      socket.onclose = () => {
        if (!isCurrentMonitorConnection()) return
        monitor.socket = null
        monitor.src = null
        if (monitor.objectUrl) URL.revokeObjectURL(monitor.objectUrl)
        monitor.objectUrl = null
        monitor.image = null
        // 换页会使旧通道失效，重新通过 API 鉴权，不能复用已核销的凭据。
        this.screenTimer = setTimeout(() => {
          if (monitor.autoRefresh && monitorGeneration === monitor.sessionGeneration) this.initMonitor()
        }, 1000)
      }
    },
    async refreshMonitor (monitorGeneration = this.monitor.sessionGeneration) {
      const monitor = this.monitor
      if (!monitor.autoRefresh || monitorGeneration !== monitor.sessionGeneration || !monitor.src) return
      let resp = null
      try {
        resp = await this.getMonitorImage(monitor.src)
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
      }
      // 离开页面或新一轮查看开始后，不接受旧请求，也不恢复旧轮询。
      if (!monitor.autoRefresh || monitorGeneration !== monitor.sessionGeneration) return
      if (resp && resp.value && !resp.value.error) {
        monitor.image = `data:image/jpeg;base64,${resp.value}`
      } else if (resp?.value?.error === 'browser_frame_unavailable') {
        // worker 异步启动推帧，首帧未到或换页期间继续等待。
        monitor.image = null
      } else {
        this.stopMonitor()
        return
      }
      this.screenTimer = setTimeout(() => this.refreshMonitor(monitorGeneration), 1000 / monitor.frame)
    },
    async handleControlBtnClick () {
      if (!this.showControlBtn || !this.taskSetting.autoRefresh) return
      this.cleanIframe()
      const controlGeneration = this.dialog.sessionGeneration
      this.dialog.show = true
      this.dialog.loading = true
      try {
        // 只在实际打开接管时获取新租约，不复用已领取或过期的 iframe 地址。
        const resp = await this.getTaskControl({ task_id: this.taskId, taskBackend: this.taskBackend })
        if (!this.dialog.show || controlGeneration !== this.dialog.sessionGeneration) return
        this.controlIframeSrc = resp?.control_path || ''
      } finally {
        if (controlGeneration === this.dialog.sessionGeneration && !this.controlIframeSrc) {
          this.dialog.loading = false
        }
      }
    },
    handleMonitorClick () {
      if (this.monitor.image) {
        this.monitor.dialog.show = true
      }
    },
    handleIframeLoad () {
      // 旧 Selenium DevTools 保留原布局适配；新接管页自行显示连接和首帧状态。
      if (/\/rpa\/[^/]+\/control\//.test(this.controlIframeSrc || '')) {
        this.adjustLegacyControlLayout(this.dialog.sessionGeneration)
        return
      }
      if (this.controlIframeSrc) this.dialog.loading = false
    },
    adjustLegacyControlLayout (controlGeneration) {
      // controlGeneration 绑定本次接管弹窗，关闭后不再等待或修改旧 iframe。
      if (!this.dialog.show || controlGeneration !== this.dialog.sessionGeneration) return
      const contentDocument = this.$refs.iframe?.contentDocument
      const screencast = contentDocument?.querySelector('.screencast')
      if (!screencast) {
        this.dialog.layoutTimer = setTimeout(() => this.adjustLegacyControlLayout(controlGeneration), 500)
        return
      }
      // 隐藏 DevTools 工具栏和侧栏。
      screencast.firstElementChild.style.display = 'none'
      screencast.parentElement.lastElementChild.style.display = 'none'
      screencast.parentElement.shadowRoot.querySelector('div .shadow-split-widget-sidebar')?.remove()
      screencast.parentElement.shadowRoot.querySelector('div .shadow-split-widget-resizer')?.remove()
      screencast.querySelector('.screencast-viewport').style.margin = 'auto'
      contentDocument.dispatchEvent(new Event('resize'))
      this.dialog.loading = false
    },
    cleanIframe () {
      clearTimeout(this.dialog.layoutTimer)
      this.dialog.layoutTimer = null
      this.dialog.sessionGeneration += 1
      this.controlIframeSrc = ''
      this.dialog.show = false
      this.dialog.loading = false
    }
  }
}
